import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { getStorage } from "firebase/storage";  // 이 줄을 추가합니다.

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);  // 이 줄을 추가합니다.

export const getUserData = async (userId) => {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists()) {
        return userSnap.data();
    } else {
        // 사용자 문서가 없으면 새로 생성
        await setDoc(userRef, { aiQuizCount: 5, customApiKey: null });
        return { aiQuizCount: 5, customApiKey: null };
    }
};

export const updateUserAiQuizCount = async (userId, newCount) => {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, { aiQuizCount: newCount });
};

export const updateUserCustomApiKey = async (userId, apiKey) => {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, { customApiKey: apiKey });
};

export const updateUserGptModel = async (userId, gptModel) => {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, { gptModel: gptModel });
};